import useSWR from 'swr';
import * as _ from 'lodash';
import { createBatchResolver } from '../shared/utils/batch-resolver';
import { getBoardItemsByIds, BoardItem } from '@gorilla/common/src/lib/monday-api/api';
import { mondayClient } from '../services/monday';
import { searchClients } from '../services/portal';

export const itemBatchResolver = createBatchResolver<number, BoardItem | undefined>(async (itemsIds: number[]) => {
  const items = await getBoardItemsByIds(mondayClient, itemsIds, '', { withoutBoardRelationValue: true, withoutMirrorValue: true });
  const itemsById = _.keyBy(items, 'id');

  return itemsIds.reduce(
    (memo, itemId) => {
      const item = itemsById[itemId];

      if (!item) {
        memo[itemId] = undefined;
        return memo;
      }

      memo[itemId] = item;
      return memo;
    },
    {} as Record<number, BoardItem | undefined>,
  );
});

export function useItems(itemIds: number[]) {
  let {
    data: items,
    isLoading,
    error,
  } = useSWR(`/items/${itemIds.join('/')}`, async () => (itemIds.length ? itemBatchResolver.resolveItems(itemIds) : []), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
  });

  return {
    items,
    isLoading,
    error,
  };
}

export function useItem(itemId?: number) {
  const { items, isLoading, error } = useItems(itemId ? [itemId] : []);

  return {
    item: items ? (items[0] ? items[0] : null) : undefined,
    isLoading,
    error,
  };
}

export function useAllClientSettings(clientsBoardId: number) {
  let {
    data: allClientsSettings,
    isLoading,
    error,
  } = useSWR(
    `/clients-search/${clientsBoardId}`,
    async () => {
      return searchClients(clientsBoardId);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  return {
    allClientsSettings: allClientsSettings?.results,
    isLoading,
    error,
  };
}
